import { tWithKeyAttr as t } from "../i18nHelper";
import { Category } from "../types/types";

export const getMenuCategories = (): Record<Category, string> => ({
  [Category.Messages]: t("MESSAGES"),
  [Category.Support]: t("SUPPORT_TECH_TITLE"),
  [Category.Terms]: t("TERMS_POLICY"),
  [Category.Profile]: t("MY_PROFILE"),
  [Category.Main]: t("HOME_PAGE"),
  [Category.RecordMeeting]: t("RECORD_MEETING"),
  [Category.Library]: t("PRIVENCER_LIBRARY"),
  [Category.Calendar]: t("CALENDAR"),
  [Category.Forum]: t("FORUM"),
  [Category.Users]: t("USERS_PAGE_TITLE"),
  [Category.TreatmentPlan]: t("TREATMENT_PLANS"),
  [Category.Tutorial]: t("TUTORIAL_VIDEOS"),
});
export interface IContactUsTheme {
  title: string;
  text: string;
}
